import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface AuthState {
  isAuthenticated: boolean
  user: { name: string; email: string } | null
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ name: string; email: string }>) => {
      state.isAuthenticated = true
      state.user = action.payload
      // In a real app, we'd save a token to localStorage here
      localStorage.setItem("isAuthenticated", "true")
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      localStorage.removeItem("isAuthenticated")
    },
    checkAuth: (state) => {
      const isAuth = localStorage.getItem("isAuthenticated") === "true"
      if (isAuth) {
        state.isAuthenticated = true
        state.user = { name: "Admin", email: "admin@example.com" } // Mock user
      }
    },
  },
})

export const { login, logout, checkAuth } = authSlice.actions
export default authSlice.reducer
